<div class="floors-groups-table">
    <ev-grid-table [gridModel]="displayTemplate">

        <!-- Header row -->
        <ev-th>
            @for (column of headers; track $index) {
                @if (column.isSortable) {
                    <ev-td
                        [area]="column.prop"
                        (click)="updateSort(column.prop)"
                        [isSelectable]="true"
                        [textAlignment]="column.textAlignment ?? 'left'"
                        [selected]="sortConfig().sortOption.prop === column.prop"
                    >
                        {{ column.name.toUpperCase() }}
                    </ev-td>
                } @else {
                    <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                        {{ column.name.toUpperCase() }}
                    </ev-td>
                }
            }
        </ev-th>

        <!-- Data rows -->
        @for (rowData of tableData(); track rowData.groupKeyValue) {
            <ev-tr class="ev-row">
                <ev-td area="groupKeyValue" header="Etg" column [fontBold]="sortConfig().sortOption.prop === 'groupKeyValue'">
                    <div class="column-data">{{ rowData.groupKeyValue }}. etg</div>
                </ev-td>
                <ev-td area="total" header="Tot" column textAlignment="right" [fontBold]="sortConfig().sortOption.prop === 'total'">
                    <div class="column-data">{{ rowData.total?.numberOfUnits }}</div>
                </ev-td>
                <ev-td area="sold" header="Solgt" column textAlignment="right" [fontBold]="sortConfig().sortOption.prop === 'sold'">
                    <div class="column-data">{{ rowData.sold?.numberOfUnits }}</div>
                </ev-td>
                <ev-td area="unsold" header="Usolgt" column textAlignment="right" [fontBold]="sortConfig().sortOption.prop === 'unsold'">
                    <div class="column-data">{{ rowData.unsold?.numberOfUnits }}</div>
                </ev-td>
            </ev-tr>
        }

    </ev-grid-table>
</div>
